import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconYen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconYen"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.44934 6.67342 2 12.375 2C18.0766 2 22.75 6.44934 22.75 12C22.75 17.5507 18.0766 22 12.375 22C6.67342 22 2 17.5507 2 12ZM8.57055 6.94169L7.44169 7.92945L11.2222 12.25H9V13.75H11.25V18H12.75V13.75H15V12.25H12.7778L16.5583 7.92945L15.4294 6.94169L12 10.8611L8.57055 6.94169Z" fill="currentColor"/></CentralIconBase>;
});

export default IconYen;
